/**
 * Mobile thumbnail strip — make it drive the gallery in BOTH image modes.
 *
 * The theme only wires thumbnail clicks when "Stack images on desktop" is OFF:
 *
 *   if (!options.stackProductImages && options.showThumbnails) {
 *     delegateElement.on('click', '.Product__SlideshowNavImage', _switchToImage)
 *   }
 *
 * With stacking ON the thumbnails become plain #Media anchors. That is fine on
 * desktop, where the images really are stacked and the anchor scrolls to one —
 * but below 1008px the theme still renders a Flickity carousel, so the anchors
 * point at cells that are not laid out and clicking appears to do nothing.
 *
 * Rather than re-implement carousel control, this forwards the click to the
 * theme's own (visually hidden) dot nav, which the theme already handles. It
 * also mirrors the selected state back so the strip tracks swipes.
 */
(function() {
  'use strict';

  var gallery = document.querySelector('.Product__Gallery--mobileThumbs');
  if (!gallery) return;

  var strip = gallery.querySelector('.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller');
  var mobileNav = document.querySelector('.Product__SlideshowMobileNav');
  if (!strip || !mobileNav) return;

  var DESKTOP = 1008; // below this the gallery is a carousel in either mode

  function thumbs() {
    return Array.prototype.slice.call(strip.querySelectorAll('.Product__SlideshowNavImage'));
  }
  function dots() {
    return Array.prototype.slice.call(mobileNav.querySelectorAll('.dot'));
  }

  function markSelected(index) {
    thumbs().forEach(function(t, i) {
      t.classList.toggle('is-selected', i === index);
    });
  }

  strip.addEventListener('click', function(e) {
    var thumb = e.target.closest('.Product__SlideshowNavImage');
    if (!thumb) return;
    if (window.innerWidth >= DESKTOP) return;   // desktop behaviour is the theme's

    var index = thumbs().indexOf(thumb);
    var dot = dots()[index];
    if (!dot) return;

    // Stop the #Media anchor from jumping the page
    e.preventDefault();

    // The dot nav is hidden by CSS but still in the DOM, and the theme's
    // delegated handler fires regardless of visibility.
    dot.click();
    markSelected(index);

    // Keep the tapped thumbnail in view in the scroller
    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  });

  // Mirror the carousel back onto the strip when the shopper swipes the main
  // image: the theme keeps the dots in sync, so watch those.
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function() {
      var current = dots().findIndex(function(d) { return d.classList.contains('is-selected'); });
      if (current > -1) markSelected(current);
    });
    dots().forEach(function(d) {
      observer.observe(d, { attributes: true, attributeFilter: ['class'] });
    });
  }
})();
